import { apiRequest } from '../client'
import type {
  RolePermissionsResponse,
  UpdateRolePermissionsRequest,
} from '../types'

function withTenantId(path: string, tenantId?: number | null) {
  if (!tenantId) return path
  const params = new URLSearchParams({ tenantId: tenantId.toString() })
  return `${path}?${params.toString()}`
}

export const rolesApi = {
  list: (tenantId?: number | null) =>
    apiRequest<RolePermissionsResponse>(
      withTenantId('/api/v0/admin/roles', tenantId),
    ),

  updatePermissions: (
    role: string,
    data: UpdateRolePermissionsRequest,
    tenantId?: number | null,
  ) =>
    apiRequest<{ ok: boolean; role: string; actions: Array<string> }>(
      withTenantId(`/api/v0/admin/roles/${role}/permissions`, tenantId),
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
    ),
}
